import React from 'react';
import { Breadcrumb } from 'react-bootstrap';
import { NavLink, useLocation } from 'react-router-dom';

const BreadcrumbList = ({ items = [{ to: '/', text: 'Home' }], basePath = "", title }) => {
  const location = useLocation();

  // include query/hash so /x?y=1 is not treated the same as /x
  const current = `${location.pathname}${location.search}${location.hash}`;
  
  return (
    <Breadcrumb className="breadcrumb-container d-inline-block" style={{marginBottom: "12px"}}>
      {items.map((breadcrumb, bIndex) => (
        <Breadcrumb.Item key={`breadCrumb.${bIndex}`} linkAs={NavLink} linkProps={{
          to: `${basePath}${breadcrumb.to}`, onClick: (e, target) => {
            if (current === basePath+breadcrumb.to) {
              e.preventDefault();
              window.location.reload();
            }
          } }}>
          {bIndex===0 && title ? title : breadcrumb.title || breadcrumb.text}
        </Breadcrumb.Item>
      ))}
    </Breadcrumb>
  );
};

export default BreadcrumbList;
